module.exports = __webpack_public_path__ + "static/media/IOD_Seal.a74cd662.png";